import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ConfigProvider, Spin, App as AntApp } from 'antd';
import { AuthProvider } from '../lib/auth';
import { queryClient } from '../lib/react-query';
import { antdTheme, applyBrandCssVariables, brand } from '../theme/brand';

function BrandCssVars() {
  React.useEffect(() => {
    applyBrandCssVariables();
  }, []);
  return null;
}

export const AppProvider = ({ children }) => {
  return (
    <React.Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
            background: brand.background,
          }}
        >
          <Spin size="large" />
        </div>
      }
    >
      <ConfigProvider theme={antdTheme}>
        <AntApp>
          <BrandCssVars />
          <QueryClientProvider client={queryClient}>
            <Router>
              <AuthProvider>{children}</AuthProvider>
            </Router>
          </QueryClientProvider>
          <ToastContainer autoClose={2000} hideProgressBar />
        </AntApp>
      </ConfigProvider>
    </React.Suspense>
  );
};
